/* eslint-disable max-len */
export const API_POLL_INTERVAL = 2000;
export const API_POLL_INTERVAL_CONTENT_AUDIT = 5000;
export const API_POLL_INTERVAL_BULK_DA_CHECKER = 2000;
export const API_POLL_INTERNAL_LINKING_INTERVAL = 2000;
export const MESSAGE_ERROR_DURATION = 1.5;
export const QUERY_DEBOUNCE_WAIT = 500;
export const RECAPTCHA_KEY = '6LeUKAAbAAAAANq3qpeYPEaHrfT5jeAFQDiSOFtW';
export const FREE_PLAN_PROJECT_ID = 1328;
export const FREE_PLAN_PROJECT_DOMAIN = 'tesla.com';
export const KEYWORD_DETAIL_API_POLL_INTERVAL = 2000;
export const KEYWORD_DETAIL_TIME_INTERVAL = 5;
export const BACKLINK_API_API_POLL_INTERVAL = 4000;
export const COMPETITOR_RESEARCHER_API_POLL_INTERVAL = 5000;
export const BACKLINK_RESEARCHER_API_POLL_INTERVAL = 10000;
export const DELETE_ALERT_INTERVAL = 5000;
export const EMAIL_VERIFY_API_POLL_INTERVAL = 5000;
export const GSC_PROPERTIES_PAGE_SIZE= 10;
export const SITE_EVENT_PAGE_SIZE= 10;
export const FREE_PLAN_ID = 11;
export const STARTER_PLAN_ID = 10;
export const GROWTH_PLAN_ID = 1;
export const PRO_PLAN_ID = 8;
export const CUSTOM_PLAN_ID = 5;
export const AGENCY_STARTER_ID = 1012;
export const COMMUNITY_EDITION_ID = 1025;

export const KE_API_MAX_NUMBER_OF_POLLS = 65;
export const CR_API_MAX_NUMBER_OF_POLLS = 40;
export const KE_API_POLL_INTERVAL = 1000;
export const BUSINESS_PLAN_ID = 12;
export const CA_BASIC_PLAN_ID = 3;


export enum SDATopicalMainTableFilterEnum {
  pillar_page = 'Pillar Page',
  Keyword = 'Keyword',
}

export enum OTTOTopicalModalTableFilterEnum {
  title = 'Title',
  keyword = 'Keyword',
  categories = 'Categories',
  searchIntent = 'Search Intent',
}
export const SETopicalAuthorityTableFilterEnum = {
  domain: 'Domain / Central entity',
  broadTopic: 'Broad topic',
  topicAuthority: 'Topic dominance',
  topicWeight: 'Topic weight',
  avgPosition: 'Avg. Position',
  keyword: 'Keyword',
  searchVolume: 'Search volume',
  position: 'Position',
  rankingUrl: 'Ranking URL',
};

export const SDATopicalMainTableFilterList = [
  {id: 1, name: 'exclude', header: SDATopicalMainTableFilterEnum.pillar_page, text: '', type: undefined, active: false, isSearch: true, customFields: [
    {label: 'Contains', operator: 'contains'},
  ]},
  {id: 2, name: 'exclude', header: SDATopicalMainTableFilterEnum.Keyword, text: '', type: undefined, active: false, isSearch: false, customFields: [
    {label: 'Contains', operator: 'contains'},
  ]},
];

export const OTTOTopicalModalTableFilterList = [
  {id: 1, name: 'checkboxes', header: OTTOTopicalModalTableFilterEnum.categories, customCategoryType: 'category', filterTypes: [], type: undefined, active: false},
  {id: 2, name: 'checkboxes', header: OTTOTopicalModalTableFilterEnum.searchIntent, customCategoryType: 'category', filterTypes: [], type: undefined, active: false},
  {id: 3, name: 'exclude', header: OTTOTopicalModalTableFilterEnum.keyword, text: '', type: undefined, active: false, isSearch: false, customFields: [
    {label: 'Contains', operator: 'contains'},
  ]},
  {id: 4, name: 'exclude', header: OTTOTopicalModalTableFilterEnum.title, text: '', type: undefined, active: false, isSearch: false, customFields: [
    {label: 'Contains', operator: 'contains'},
  ]},
];


export const TopicalAuthorityBreakDownTableFilterList = [
  {id: 1, name: 'exclude', header: SETopicalAuthorityTableFilterEnum.broadTopic, text: '', type: undefined, active: false, isSearch: false, customFields: [
    {label: 'Contains', operator: 'contains'},
  ]},
  {id: 2, name: 'exclude', header: SETopicalAuthorityTableFilterEnum.topicAuthority, text: '', type: 'number', active: false, customFields: [
    {label: 'Greater or equal', operator: 'contains'},
  ]},
  // {id: 3, name: 'exclude', header: SETopicalAuthorityTableFilterEnum.topicWeight, text: '', type: 'number', active: false, customFields: [
  //   {label: 'Greater or equal', operator: 'contains'},
  // ]},
  {id: 4, name: 'exclude', header: SETopicalAuthorityTableFilterEnum.avgPosition, text: '', type: 'number', active: false, customFields: [
    {label: 'Greater or equal', operator: 'contains'},
  ]},
];

export const TopicalAuthorityGapTableFilterList = [
  {id: 1, name: 'exclude', header: SETopicalAuthorityTableFilterEnum.broadTopic, text: '', type: undefined, active: false, isSearch: false, customFields: [
    {label: 'Contains', operator: 'contains'},
  ]},
  {id: 2, name: 'exclude', header: SETopicalAuthorityTableFilterEnum.keyword, text: '', type: undefined, active: false, isSearch: false, customFields: [
    {label: 'Contains', operator: 'contains'},
  ]},
  {id: 3, name: 'exclude', header: SETopicalAuthorityTableFilterEnum.searchVolume, text: '', type: 'number', active: false, customFields: [
    {label: 'Greater or equal', operator: 'contains'},
  ]},
  {id: 4, name: 'exclude', header: SETopicalAuthorityTableFilterEnum.position, text: '', type: 'number', active: false, customFields: [
    {label: 'Greater or equal', operator: 'contains'},
  ]},
  {id: 5, name: 'exclude', header: SETopicalAuthorityTableFilterEnum.rankingUrl, text: '', type: undefined, active: false, isSearch: false, customFields: [
    {label: 'Contains', operator: 'contains'},
  ]},
];

export enum SDAQuestMainTableFilterEnum {
  query = 'Query',
}

export const platformContent = (whitelabelOtto, uuid) => [
  {
    name: 'Google Tag Manager',
    content: [
      {
        title: 'Google Tag Manager',
        description: `We have a video guide on how to install ${whitelabelOtto} SEO on WordPress. Watch below and follow the steps!`,
        videoUrl: 'https://www.loom.com/embed/cf0e531e520f436c8253b1c9c2e4c855?sid=02b348c6-8a6b-44bb-879e-640be90f2751',
      },
      {
        heading: 'Step 1: Create A New Tag',
        description: 'From the main menu, navigate to Tags and click New to start setting up a new tag.',
        imageUrl: '/img/app-installation-step-1.png',
      },
      {
        heading: 'Step 2: Name And Configure The Tag',
        description: 'Give the tag a name, such as SearchAtlas Tracking. Then, click on Tag Configuration to add its settings.',
        imageUrl: '/img/app-installation-step-2.png',
      },
      {
        heading: 'Step 3: Select Custom HTML',
        description: 'Under the tag options, scroll down to Custom and choose Custom HTML as the tag type.',
        imageUrl: '/img/app-installation-step-3.png',
      },
      {
        heading: 'Step 4: Insert The SearchAtlas Script',
        description: 'Copy and paste the SearchAtlas script into the HTML field, ensuring that all necessary parameters, such as your unique app token, are correctly inserted.',
        script: '<script>',
      },
      {
        heading: 'Step 5: Set The Trigger',
        description: 'Under Triggering, select All Pages so the script runs across your entire site. Then, click Save to apply the changes.',
        imageUrl: '/img/app-installation-step-5.png',
      },
      {
        heading: 'Step 6: Publish The Tag',
        description: 'Give the tag a name, such as SearchAtlas Tracking. Then, click on Tag Configuration to add its settings.',
        imageUrl: '/img/app-installation-step-6-1.png',
        imageUrl2: '/img/app-installation-step-6-2.png',
      },
    ],
  },
  {
    name: 'WordPress',
    content: [
      {
        title: 'WordPress Installation',
        description: `We have a video guide on how to install ${whitelabelOtto} SEO on WordPress. Watch below and follow the steps!`,
        videoUrl: 'https://www.loom.com/embed/4369bc50fb3e4a6e8c6f17f307f5691e?sid=6361c106-6ad6-412f-8d66-720019d3249e',
      },
      {
        heading: 'Step 1:',
        description: 'Click the SearchAtlas logo in the left-hand menu.',
        // imageUrl: 'https://searchatlas.com/wp-content/uploads/2024/04/image2.webp',
      },
      {
        heading: 'Step 2:',
        description: 'Navigate to "General Settings".',
        // imageUrl: 'https://searchatlas.com/wp-content/uploads/2024/04/image3.webp',
      },
      {
        heading: 'Step 3:',
        description: `Check the "Enable ${whitelabelOtto}" option`,
      },
      {
        heading: 'Step 4',
        description: `Paste the ${whitelabelOtto} UUID: ${uuid}`,
        // imageUrl: 'https://searchatlas.com/wp-content/uploads/2024/04/image7.webp',
      },
    ],
  },
  {
    name: 'Shopify',
    content: [
      {
        title: 'Shopify',
        description: `We have a video guide on how to install ${whitelabelOtto} SEO on Shopify. Watch below and follow the steps!`,
        videoUrl: 'https://www.loom.com/embed/5481d00cd9fb4240a48ec4ea429b6c51?sid=179c6891-1d51-4c82-b5a1-2a8d081d5a11',
      },
      {
        heading: 'Step 1: Accessing Theme Code',
        description: 'Go to Themes, select the theme you want to edit and then click on 3 dots to find the Edit Code button',
        imageUrl: 'https://searchatlas.com/wp-content/uploads/2024/04/image4.webp',
      },
      {
        heading: 'Step 2: Insert Script into theme.liquid',
        description: 'Open your Shopify theme editor and navigate to the theme.liquid file. Locate the <head> section or the appropriate placement within the file, then paste the provided script',
        script: '<script>',
      },
    ],
  },
  {
    name: 'Webflow',
    content: [
      {
        title: 'Webflow',
        description: `We have a video guide on how to install ${whitelabelOtto} SEO on Webflow. Watch below and follow the steps!`,
        videoUrl: 'https://www.loom.com/embed/a3bdaa56936d4b44842a4bf1924ba429?sid=1d7c3761-5554-43bd-b414-067640940c3d',
      },
      {
        heading: 'Step 1: Access Website Settings',
        description: 'Navigate to your Webflow project’s settings and go to the Custom Code',
        imageUrl: 'https://searchatlas.com/wp-content/uploads/2024/04/image6.webp',
      },
      {
        heading: 'Step 2: Insert Code in Custom Head Section',
        description: 'After selection of Custom Code section, paste the code into the Head Code area. Save your changes and publish your site.',
        script: '<script>',
      },

    ],
  },
  {
    name: 'Squarespace',
    content: [
      {
        title: 'Squarespace',
        description: `We have a video guide on how to install ${whitelabelOtto} SEO on Squarespace. Watch below and follow the steps!`,
        videoUrl: 'https://www.loom.com/embed/459ce062b9ea4318aea9c9f3aebfe9a0?sid=356d0ba9-691d-4f1e-8e36-120b9ef6b8b2',
      },
      {
        heading: 'Step 1: Access Advanced Settings',
        description: 'Go to your Squarespace Dashboard, navigate to Settings, then select Advanced.',
        imageUrl: '/img/app-installation-square-space-step-1.png',
      },
      {
        heading: 'Step 2: Open Code Injection',
        description: 'Click on Code Injection to access the header, footer, and lock screen code fields.',
        imageUrl: '/img/app-installation-square-space-step-2.png',
      },
      {
        heading: 'Step 3: Insert and Save',
        description: 'Copy and paste your SearchAtlas script into the Header section and click Save to apply the changes.',
        script: '<script>',
      },
    ],
  },
  {
    name: 'Wix',
    content: [
      {
        title: 'Wix',
        description: `We have a video guide on how to install ${whitelabelOtto} SEO on Wix. Watch below and follow the steps!`,
        videoUrl: 'https://www.loom.com/embed/b991de7519fe4f1ba391cccfd1b39c5a?sid=35df7f29-57ae-443b-99b6-0b02056b1e93',
      },
      {
        heading: 'Step 1: Access Custom Code in Wix',
        description: 'Go to your Wix Dashboard, navigate to Settings > Custom Code, and insert the SearchAtlas script in the appropriate section.',
        imageUrl: 'https://searchatlas.com/wp-content/uploads/2024/09/step1.png',
        imageUrl2: 'https://searchatlas.com/wp-content/uploads/2024/09/step-1-1.png',

      },
      {
        heading: 'Step 2: Add Your SearchAtlas Pixel',
        description: 'Copy and paste the pixel, insert it into the designated field, and click Apply!',
        script: '<script>',
      },
    ],
  },
  {
    name: 'ClickFunnels',
    content: [
      {
        title: 'ClickFunnels',
        description: `We have a video guide on how to install ${whitelabelOtto} SEO on ClickFunnels. Watch below and follow the steps!`,
        videoUrl: 'https://searchatlas.com/wp-content/uploads/2024/11/ClickFunnels-OTTO-install.mp4',
      },
      {
        heading: 'Step 1: Navigate to Site Settings',
        description: 'Go to your ClickFunnels dashboard and navigate to Site Settings to access customization options for your site.',
        imageUrl: '/img/app-installation-click-funnels-step-1.png',
      },
      {
        heading: 'Step 2: Add Script to Header Code',
        description: 'Insert the script into the header section to ensure it loads properly across your site.',
        script: '<script>',

      },
      {
        heading: 'Step 3: Click on update',
        description: 'Apply the changes by saving and updating your site to ensure the script is properly integrated.',
        imageUrl: '/img/app-installation-click-funnels-step-3.png',
      },
    ],
  },
  {
    name: 'Custom Installation',
    content: [
      {
        title: 'Custom Installation Guide',
        // description: `We have a video guide on how to install ${whitelabelOtto} SEO on Shopify. Watch below and follow the steps!`,
        // videoUrl: 'https://www.loom.com/embed/d869991854394109b0dcf6c393e48efd?sid=121d8491-eadc-4e3b-acaa-1c34093b25b7',
      },
      {
        heading: 'Step 1  : Find the header.',
        description: 'Add the pixel in the header.',
      },
      {
        heading: 'Step 2  : Step 2: Add the pixel in the header.',
        description: 'Copy the pixel from and paste it into the header section of your custom site’s code.',
        script: '<script>',
      },
    ],
  },
  {
    name: 'GHL',
    content: [
      {
        title: 'GHL Installation Guide',
        description: `We have a video guide on how to install ${whitelabelOtto} SEO on GHL Website. Watch video and follow the steps!`,
        videoUrl: 'https://www.loom.com/embed/cd35c206bc6a4d90a125f4a3e1b7d618?sid=da38a7a8-dcbb-49f2-9ce3-13449052327a',
      },
      {
        heading: 'Step 1',
        description: 'Navigate to Your Website Settings Go to GHL Dashboard → Click on Sites → Select Website',
        imageUrl: '',
      },
      {
        heading: 'Step 2',
        description: 'Access Tracking Code Settings Inside the Website settings, click on Settings',
      },
      {
        heading: 'Step 3',
        description: `Add the ${whitelabelOtto} SEO Pixel Scroll down to the Head Tracking Code field → Paste the ${whitelabelOtto} SEO Pixel script → Click Save`,
      },
    ],
  },
];
